import React from 'react';
import { Provider } from 'react-redux';
import App from './components/App';
import { Experiment, ExperimentProvider } from './components/Experiment';
import { LocalizationContextProvider } from '@homeaway/react-localization-components';

/**
 * Basic provider wrapping. This has been externalized in order to
 * enable hot module replacement features.
 */

/* istanbul ignore next */
function Root({ store, siteContext }) {
  return (
    <Provider store={store}>
      <ExperimentProvider>
        <Experiment name="HA_PTA_HP_AA" earlyReport>
          <LocalizationContextProvider siteContext={siteContext}>
            <App />
          </LocalizationContextProvider>
        </Experiment>
      </ExperimentProvider>
    </Provider>
  );
}

export default Root;
